import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//component:
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginLeft: 25,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    rtl: {
        textAlign: 'right',
    }
});

class EditContadorMaquina extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.contador.id ? this.props.contador.id : uuidv4(),
            iTipo: this.props.contador.iTipo ? this.props.contador.iTipo : 0,
            tipoContador: this.props.contador.tipoContador ? this.props.contador.tipoContador : 'Euros',
            maquina: this.props.contador.maquina ? this.props.contador.maquina : null,
            maquinaId: this.props.contador.maquinaId ? this.props.contador.maquinaId : this.props.maquinaId,
            dcLectura: this.props.contador.dcLectura ? this.props.contador.dcLectura : [],
            numOrden: this.props.contador.numOrden ? this.props.contador.numOrden : 1,
            ultMultiplicador: this.props.contador.ultMultiplicador ? this.props.contador.ultMultiplicador : 1.0,
            ultPrecio: this.props.contador.ultPrecio ? this.props.contador.ultPrecio : 1.0,
            activa: this.props.contador.activa ? this.props.contador.activa : false,
            anulado: this.props.contador.anulado ? this.props.contador.anulado : false,
            contadorCompra: this.props.contador.contadorCompra ? this.props.contador.contadorCompra : 0,
            contadorCompraSalidas: this.props.contador.contadorCompraSalidas ? this.props.contador.contadorCompraSalidas : 0,
            redsysMachineId: this.props.contador.redsysMachineId,

        };

    };

    //select:
    handleSelectChange = e => {
        const id = parseInt(e.target.value) - 1;
        const tipo = ['Euros', 'Tokens', 'Tickets', 'Cambio', 'Regalos', 'VISAs'];
        this.setState({ ...this.state, iTipo: id, tipoContador: tipo[id] });
    };

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };


    //checkbox:
    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>

                    <FormControl className={classes.formControl}>

                        <InputLabel htmlFor="zona-placeholder">Tipo Contador</InputLabel>
                        <Select
                            native
                            value={this.state.iTipo + 1}
                            onChange={(event) => this.handleSelectChange(event)}
                            name="iTipo"
                            input={<Input id="input-tipos" />}
                        >
                            <option key={'cont_0'} value={1}>Euros</option>
                            <option key={'cont_1'} value={2}>Tokens</option>
                            <option key={'cont_2'} value={3}>Tickets</option>
                            <option key={'cont_3'} value={4}>Cambio</option>
                            <option key={'cont_4'} value={5}>Regalos</option>
                            <option key={'cont_5'} value={6}>VISAs</option>
                        </Select>

                    </FormControl>


                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'numOrden'}
                            label={'Num. Order'}
                            placeholder={'Num. Order'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.numOrden}
                            onChange={(event) => this.handleValueChange(event, 'numOrden')}
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'ultMultiplicador'}
                            label={'Ult. Multiplicador'}
                            placeholder={'Ult. Multiplicador'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: FloatNumberFormatInput}}
                            // eslint-disable-next-line
                            inputProps={{decimal:3}}
                            value={this.state.ultMultiplicador}
                            onChange={(event) => this.handleValueChange(event, 'ultMultiplicador')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'ultPrecio'}
                            label={'Ult. Precio'}
                            placeholder={'Ult. Precio'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: FloatNumberFormatInput }}
                            // eslint-disable-next-line
                            inputProps={{decimal:3}}
                            value={this.state.ultPrecio}
                            onChange={(event) => this.handleValueChange(event, 'ultPrecio')}
                        />
                    </FormControl>

                </div>
                <div className={classes.containerPair}>

                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'contadorCompra'}
                            label={'Valor Inicial'}
                            placeholder={'Valor Inicial'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.contadorCompra}
                            onChange={(event) => this.handleValueChange(event, 'contadorCompra')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl} hidden={!this.props.tipoB}>

                        <TextField
                            id={'contadorCompraSalidas'}
                            label={'Valor Inicial Salidas'}
                            placeholder={'Valor Inicial Salidas'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.contadorCompraSalidas}
                            onChange={(event) => this.handleValueChange(event, 'contadorCompraSalidas')}
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>

                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'redsys'}
                            label={'REDSYS Id'}
                            placeholder={'REDSYS Id'}
                            margin="normal"
                            value={this.state.redsysMachineId}
                            onChange={(event) => this.handleValueChange(event, 'redsysMachineId')}
                        />
                    </FormControl>

                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activa}
                                    onChange={event => this.handleBooleanChange(event, 'activa')}
                                    value="Activa"
                                    color="primary"
                                />
                            }
                            label="Activa"
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.anulado}
                                    onChange={event => this.handleBooleanChange(event, 'anulado')}
                                    value="Anulado"
                                    color="primary"
                                />
                            }
                            label="Anulado"
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const contador = {
                            id: this.state.id,
                            iTipo: this.state.iTipo,
                            tipoContador: this.state.tipoContador,
                            numOrden: this.state.numOrden,
                            ultMultiplicador: this.state.ultMultiplicador,
                            ultPrecio: this.state.ultPrecio,
                            activa: this.state.activa,
                            anulado: this.state.anulado,
                            maquina: this.state.maquina,
                            maquinaId: this.state.maquinaId,
                            dcLectura: this.state.dcLectura,
                            contadorCompra: this.state.contadorCompra,
                            contadorCompraSalidas: this.state.contadorCompraSalidas,
                            redsysMachineId: this.state.redsysMachineId
                        };

                        if (this.props.checkContador(contador)) {
                            this.props.okHandler(contador);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditContadorMaquina.propTypes = {
    contador: PropTypes.object.isRequired,
    maquinaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkContador: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditContadorMaquina);